export const materials = () => {
  let columns = $(".materials--table").data("columns");
  let columnWidth = $(".materials--table--cell")
    .not(".materials--table--cell--category")
    .outerWidth();
  let offset = 0;
  let tableWidth = $(".materials--table").outerWidth();
  let displaying = Math.floor(tableWidth / columnWidth);

  $(".materials--paginate--left").on("click", function (e) {
    e.preventDefault();

    if ($(this).hasClass("is-disabled")) {
      return;
    }

    offset -= 1;

    let translateAmount = columnWidth * offset;

    $(".materials--table--cell")
      .not(".materials--table--cell--category")
      .css("transform", "translateX(-" + translateAmount + "px)");

    if (offset === 0) {
      $(this).addClass("is-disabled");
    }

    $(".materials--paginate--right").removeClass("is-disabled");
  });

  $(".materials--paginate--right").on("click", function (e) {
    e.preventDefault();

    if ($(this).hasClass("is-disabled")) {
      return;
    }

    offset += 1;

    let translateAmount = columnWidth * offset;

    $(".materials--table--cell")
      .not(".materials--table--cell--category")
      .css("transform", "translateX(-" + translateAmount + "px)");

    if (offset + displaying === columns) {
      $(this).addClass("is-disabled");
    }

    $(".materials--paginate--left").removeClass("is-disabled");
  });

  if ($(".materials--list--dropdown").length > 0) {
    $(".materials--list--dropdown").on("change", function (e) {
      e.preventDefault();

      const $yearFilter = $("#materials-filter--year");
      const $catFilter = $("#materials-filter--category");
      const params = new URLSearchParams(window.location.search);

      // Only update params for filters that are rendered on this block.
      if ($yearFilter.length) {
        const yearVal = $yearFilter.val() || "";
        if (yearVal) {
          params.set("myear", yearVal);
        } else {
          params.delete("myear");
        }
      }

      if ($catFilter.length) {
        const catVal = $catFilter.val() || "";
        if (catVal) {
          params.set("mcat", catVal);
        } else {
          params.delete("mcat");
        }
      }

      // Reload with normalized path (remove trailing slash except for root)
      let path = window.location.pathname;
      if (path.length > 1 && path.endsWith("/")) {
        path = path.slice(0, -1);
      }
      const query = params.toString();
      window.location.href = query ? `${path}?${query}` : path;
    });
  }
};
